import moment from "moment-timezone";
import { nanoid } from "nanoid";

import * as pdfApi from "@/apiv2/pdfCustomisation";
import * as alertActions from "@/redux/alerts/alerts.actions";
import { handleError } from "@/redux/utils/error";
import { STATUS } from "@/utils/constants";
import * as date from "@/utils/date";

import { dependencies } from "../../../../package.json";

import {
  RESET,
  SET_IS_FETCHING_TEMPLATE_STATUS,
  SET_IS_SAVING_TEMPLATE_STATUS,
  SET_TEMPLATE,
} from "./editor.actionTypes";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setIsFetchingTemplateStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_FETCHING_TEMPLATE_STATUS,
    payload: status,
  });
};

export const setIsSavingTemplateStatus = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_SAVING_TEMPLATE_STATUS,
    payload: status,
  });
};

export const setTemplate = (data) => (dispatch) => {
  dispatch({
    type: SET_TEMPLATE,
    payload: data,
  });
};

export const fetchTemplate = (uid) => async (dispatch) => {
  try {
    dispatch(setIsFetchingTemplateStatus(STATUS.PENDING));

    const { data } = await pdfApi.getCompanyTemplate(uid)();

    dispatch(setTemplate(data));
    dispatch(setIsFetchingTemplateStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setIsFetchingTemplateStatus(STATUS.REJECTED));
    handleError(error, dispatch);
  }
};

export const saveTemplate =
  ({ uid, payload }) =>
  async (dispatch) => {
    try {
      dispatch(setIsSavingTemplateStatus(STATUS.PENDING));
      const formData = new FormData();
      formData.append("content", JSON.stringify(payload.content));
      formData.append("is_default", payload.isDefault);
      formData.append("name", payload.name);
      formData.append("description", "");
      formData.append("version", dependencies["@factory/pdf-customisation"]);

      const blob = new Blob([payload.htmlContent], { type: "text/html" });
      const htmlFile = new File(
        [blob],
        `${payload.templateKey}-${date.toLocalDateTime({
          date: moment.tz(date.getCurrentUserTimezone()),
          timezone: date.getCurrentUserTimezone(),
          format: "YYYY-MM-DDTHHmmssZ",
        })}.html`,
        { type: "text/html" }
      );
      formData.append("html_file", htmlFile);

      const { data } = await pdfApi.patchCompanyTemplate({ uid, data: formData })();

      dispatch(
        alertActions.createAlertAction(nanoid(), "Template successfully updated.", true, "success")
      );

      dispatch(setIsSavingTemplateStatus(STATUS.FULFILLED));
      return data;
    } catch (error) {
      dispatch(setIsSavingTemplateStatus(STATUS.REJECTED));
      handleError(error, dispatch);
    }
  };
